import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from "@angular/forms";

@Pipe({
  name: 'isShowError',
  standalone: true,
  pure: false
})
export class IsShowErrorPipe implements PipeTransform {

  transform(control: AbstractControl): boolean {
    return (control.touched || control.dirty) && control.invalid;
  }

}
